import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, ReactElement } from "react";
import Accordion from "../../components/general/Accordion";
import AccordionBar from "../../components/general/Accordion/components/AccordionBar";
import AccordionContent from "../../components/general/Accordion/components/AccordionContent/AccordionContent";
import AccordionItem from "../../components/general/Accordion/components/AccordionItem";
import AccordionPanel from "../../components/general/Accordion/components/AccordionPanel";
import { notUndefined } from "../../utils/type-guards/general";

type AccordionModuleProps = {
	items: ProductDetailsProps[];
};

type ProductDetailsProps = {
	label: string;
	content: string | StoryblokRichTextNode<ReactElement>;
	icon: string;
	openByDefault?: boolean | null;
};

const AccordionModule: FC<AccordionModuleProps> = ({ items }) => {
	const accordionItems = items.filter(notUndefined).map((item, index) => {
		const accordionIndex = JSON.stringify(item.content);

		return (
			<AccordionItem
				key={index}
				variant="primary"
				className="border-gray-4/10 not-last:border-b"
			>
				<AccordionBar
					label={item.label}
					accordionIndex={accordionIndex}
					icon={item.icon}
					openByDefault={item.openByDefault}
				/>
				<AccordionPanel accordionIndex={accordionIndex}>
					{item.content && <AccordionContent richtext={item.content} />}
				</AccordionPanel>
			</AccordionItem>
		);
	});

	return accordionItems.length > 0 ? (
		<Accordion className="mt-4 md:mt-6">{accordionItems}</Accordion>
	) : null;
};
export default AccordionModule;
